var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.017,
    viewBox: "0 0 17 17.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broadcast",
    transform: "translate(-47.5 -47.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M61.844,48.163s-3.332,4.192-6.459,4.192H49.231a.619.619,0,0,0-.615.622v3.734a.619.619,0,0,0,.615.622h6.154c3.127,0,6.459,4.21,6.459,4.21a.56.56,0,0,0,.925-.382V48.543A.546.546,0,0,0,61.844,48.163ZM48.615,56.09S48,55.856,48,54.845s.615-1.245.615-1.245m14.769,2.1a.9.9,0,0,0,0-1.712M56,52.355v4.979m-5.538-4.979v4.979",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M144,288v6.058a.288.288,0,0,0,.288.288H146.2a.577.577,0,0,0,.551-.747,10.451,10.451,0,0,1-1.02-3.868h.577a.577.577,0,0,0,.577-.577v-.577a.577.577,0,0,0-.577-.577h-.577",
    transform: "translate(-92.253 -230.347)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastDropDownIcon);
export default __webpack_public_path__ + "static/media/Broadcast-drop-down-icon.3aba01cb514666e4818d74c7549f2fd4.svg";
export { ForwardRef as ReactComponent };